export enum ASSESSMENT_TYPE {
  CANDIDATES = 'candidate',
  TEAM_MEMBERS = 'employee',
  PARTNERS = 'partner',
}
